/*=========================================================================================
  File Name: module-import.js
  Description: Supplier Module
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import state from './module-import-state';
import mutations from './module-import-mutations';
import actions from './module-import-actions';
import getters from './module-import-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
